'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _upgradeCatalogApi = require('self-service-api/core/api/upgradeCatalogApi');

var _productsAdapter = require('self-service-api/adapters/productsAdapter');

var _productsAdapter2 = _interopRequireDefault(_productsAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProducts = function getProducts() {
  return _upgradeCatalogApi.upgradeCatalogApi.get().then(_productsAdapter2.default);
};

exports.default = getProducts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getProducts.js
// module id = 203
// module chunks = 3 4 5